import('./bootstrap')
	.catch(err => console.info(err));
